















































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  SetupContext,
} from '@vue/composition-api';
import { getResultOfInputRules } from '@/components/composables/getRulesResult';
import { ImageFile } from '@/models/entities/ImageFile';

interface Props {
  image: ImageFile;
  maxWidth?: number;
  maxHeight?: number;
  rules?: Array<(a: any) => boolean | string>;
  nonDeletable?: boolean;
  fullSize: boolean;
}

interface State {
  maxWidth: string;
  maxHeight: string;
}

const Component = defineComponent({
  name: 'ImageUpload',

  props: {
    image: Object,
    maxWidth: String,
    maxHeight: String,
    rules: Array,
    nonDeletable: Boolean,
    fullSize: Boolean,
  },

  setup(props: Props, { root: { $store }, emit }: SetupContext) {
    const fileInput: any = ref(null);

    const state = reactive({
      maxWidth: props.maxWidth || '100',
      maxHeight: props.maxHeight || '100',
    }) as State;

    const inputValue: Ref<File | null> = ref(null);

    async function onChange(image: File) {
      if (image) {
        inputValue.value = image;

        // do not reset value on cancel
        if (fileInput.value) {
          fileInput.value.$refs.input.value = '';
        }

        // 1) dispatch store action to upload file
        const uploaded: ImageFile = await $store.dispatch('uploadFile', image);
        // 2) emit data received after upload (catch data by parent components)
        if (uploaded) emit('input', uploaded);
      } else {
        inputValue.value = null;
        emit('input', null);
      }
    }

    const error = computed(() => getResultOfInputRules(props.rules, inputValue.value));

    return {
      fileInput,
      state,
      onChange,
      error,
    };
  },
});

export default Component;
